import { MachineGuards } from 'common/bento/types/MachineConfig';

import { Model } from './model';

export enum Guard {
  ShouldAnswerCompanyCompliance = 'shouldAnswerCompanyCompliance',
  ShouldAnswerFinancialInfo = 'shouldAnswerFinancialInfo',
  ShouldReviewFinancialInfo = 'shouldReviewFinancialInfo',
}

const guards: MachineGuards<Model, Guard> = {
  shouldAnswerCompanyCompliance: ({ getModuleData }) => {
    const { shouldAskSanctionsDeclarationQuestions } =
      getModuleData().companyFinancialInfoData;

    return shouldAskSanctionsDeclarationQuestions;
  },

  shouldAnswerFinancialInfo: ({ getModuleData }) => {
    const { isMicro } =
      getModuleData().companyFinancialInfoData.viewer.company.profile;

    return !isMicro;
  },

  shouldReviewFinancialInfo: ({ shouldReviewFinancialInfo }) => {
    return shouldReviewFinancialInfo;
  },
};

export default guards;
